import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  required: {
    description: 'address.requiredMessage',
    defaultMessage: 'Required',
    id: 'qnhKPd',
  },
  name: {
    description: 'address.name',
    defaultMessage: 'Name',
    id: 'GbLdCn',
  },
  company: {
    description: 'address.companyName',
    defaultMessage: 'Company',
    id: '36govV',
  },
  companyPlaceholder: {
    description: 'address.companyPlaceholder',
    defaultMessage: 'Company Name',
    id: 'kOHQwv',
  },
  line1: {
    description: 'address.addressLine1',
    defaultMessage: 'Address',
    id: 'Ey5sZ0',
  },
  address1Placeholder: {
    description: 'address.addressLine1Placeholder',
    defaultMessage: 'Address Line 1',
    id: '/1b2m6',
  },
  address2Placeholder: {
    description: 'address.addressLine2Placeholder',
    defaultMessage: 'Address Line 2',
    id: 'xbBmu/',
  },
  address3Placeholder: {
    description: 'address.addressLine3Placeholder',
    defaultMessage: 'Address Line 3',
    id: 'EU5qwK',
  },
  city: {
    description: 'address.city',
    defaultMessage: 'City',
    id: 'e9IOPd',
  },
  suburb: {
    description: 'Australia Address Suburb',
    defaultMessage: 'Suburb',
    id: '3YeJBV',
  },
  town: {
    description: 'New Zealand Town/City',
    defaultMessage: 'Town/City',
    id: '+TyBNH',
  },
  state: {
    description: 'address.state',
    defaultMessage: 'State',
    id: 'iqxuf/',
  },
  county: {
    description: 'County field of address',
    defaultMessage: 'County',
    id: 'mvUzVE',
  },
  province: {
    description: 'address.province',
    defaultMessage: 'Province',
    id: 'rGxUHe',
  },
  postalCode: {
    description: 'address.postalCode',
    defaultMessage: 'Postal Code',
    id: 'yTpyx1',
  },
  zipCode: {
    description: 'address.zipCode',
    defaultMessage: 'Zip Code',
    id: 'Gk9uci',
  },
  postcode: {
    description: 'Australia Address postcode',
    defaultMessage: 'Postcode',
    id: 'GEKvfD',
  },
  country: {
    description: 'address.country',
    defaultMessage: 'Country',
    id: 'T7bdMy',
  },
  pasteAddress: {
    description: 'address.pasteAddress',
    defaultMessage: 'Paste US Address',
    id: 'TI0BEa',
  },
  pasteEntireAddress: {
    description: 'address.pasteEntireAddress',
    defaultMessage: 'Paste Entire US Address',
    id: 'FVZ++j',
  },
  phone: {
    description: 'address.phone',
    defaultMessage: 'Phone',
    id: 'hBvwNg',
  },
  email: {
    description: 'address.email',
    defaultMessage: 'Email',
    id: 'ir9Ir/',
  },
  returnShipFromName: {
    description: 'address.returnShipFromName',
    defaultMessage: 'Return From',
    id: 'iBh3Cw',
  },
  newShipFromLocationName: {
    description: 'address.newShipFromLocationName',
    defaultMessage: 'Name',
    id: 'SpZkN0',
  },
  defaultCountryTitle: {
    description: 'countryDropdown.defaultTitle',
    defaultMessage: 'Select Country',
    id: 'urBtdz',
  },
  defaultCountryInputTitle: {
    description: 'countryDropdown.defaultInputTitle',
    defaultMessage: 'Country',
    id: 'VAhqa/',
  },
  defaultStateInputTitle: {
    description: 'stateDropdown.defaultInputTitle',
    defaultMessage: 'State',
    id: 't4dWgw',
  },
  autoCorrect: {
    description: 'address.autoCorrect',
    defaultMessage: 'Auto Correct',
    id: 'rP9VB5',
  },
  pasteUSAddress: {
    description: 'address.pasteAddress',
    defaultMessage: 'Paste US Address',
    id: 'TI0BEa',
  },
  pasteAddressPlaceholder: {
    description: 'address.pasteAddressPlaceholder',
    defaultMessage: 'Paste or type address here...',
    id: 'EI/A2R',
  },
  save: {
    description: 'address.saveButton',
    defaultMessage: 'Save',
    id: '9XmmGz',
  },
  cancel: {
    description: 'address.cancelButton',
    defaultMessage: 'Cancel',
    id: 'FDfttK',
  },
});
